import { Button, Row, Table } from "antd";
import styled from "styled-components";

// Function to get color scheme based on table title
const getTitleStyles = (tableTitle) => {
  const titleStyles = {
    "LATEST TRADES": {
      gradient: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
      textColor: "#ffffff",
      shadow: "0 4px 15px rgba(17, 153, 142, 0.4)",
      hoverShadow: "0 6px 20px rgba(17, 153, 142, 0.6)",
    },
    "PENDING ORDERS": {
      gradient: "linear-gradient(135deg, #fbb034 0%, #ffdd00 100%)",
      textColor: "#ffffff",
      shadow: "0 4px 15px rgba(251, 176, 52, 0.4)",
      hoverShadow: "0 6px 20px rgba(251, 176, 52, 0.6)",
    },
    "REJECTION LOGS": {
      gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
      textColor: "#ffffff",
      shadow: "0 4px 15px rgba(250, 112, 154, 0.4)",
      hoverShadow: "0 6px 20px rgba(250, 112, 154, 0.6)",
    },
    "M2M ALERTS": {
      gradient: "linear-gradient(135deg, #30cfd0 0%, #330867 100%)",
      textColor: "#ffffff",
      shadow: "0 4px 15px rgba(48, 207, 208, 0.4)",
      hoverShadow: "0 6px 20px rgba(48, 207, 208, 0.6)",
    },
    "AUTO SQUARE OFF LIST": {
      gradient: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
      textColor: "#2c3e50",
      shadow: "0 4px 15px rgba(168, 237, 234, 0.4)",
      hoverShadow: "0 6px 20px rgba(168, 237, 234, 0.6)",
    },
    "ALERT": {
      gradient: "linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)",
      textColor: "#ffffff",
      shadow: "0 4px 15px rgba(255, 154, 158, 0.4)",
      hoverShadow: "0 6px 20px rgba(255, 154, 158, 0.6)",
    },
  };

  return (
    titleStyles[tableTitle] || {
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      textColor: "#ffffff",
      shadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
      hoverShadow: "0 6px 20px rgba(102, 126, 234, 0.6)",
    }
  );
};

export const RootDiv = styled.div`
  margin-top: ${(props) =>
    props?.querykey === "allTrade" || props?.querykey === "pendingTrade"
      ? "0rem"
      : "2rem"};

  @media (max-width: 1200px) {
    margin-top: ${(props) => (props?.isCustomer ? "0rem" : "2rem")};
  }
`;

export const StyledTheme = {
  Root: styled.div`
    margin-top: 2rem;
  `,
  MainHeader: styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 3rem;
    align-items: center;
    margin-bottom: 1rem;
  `,
  Title: styled.div`
    font-size: 1.2rem;
    font-weight: 700;
    color: ${(props) => getTitleStyles(props.tableTitle).textColor};
    background: ${(props) => getTitleStyles(props.tableTitle).gradient};
    position: relative;
    padding: 0.5rem 1.2rem;
    border-radius: 8px;
    box-shadow: ${(props) => getTitleStyles(props.tableTitle).shadow};
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    letter-spacing: 0.5px;
    text-transform: uppercase;
    display: inline-block;
    overflow: hidden;

    /* Glow effect - static */
    &::after {
      content: "";
      position: absolute;
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
      background: ${(props) => getTitleStyles(props.tableTitle).gradient};
      border-radius: 10px;
      opacity: 0.3;
      z-index: -1;
      filter: blur(8px);
    }

    &:hover {
      transform: translateY(-3px) scale(1.05);
      box-shadow: ${(props) => getTitleStyles(props.tableTitle).hoverShadow};
      
      &::after {
        opacity: 0.5;
      }
    }

    &:active {
      transform: translateY(-1px) scale(1.02);
    }

    @media (max-width: 1079px) {
      font-size: 1rem;
      padding: 0.4rem 1rem;
    }
  `,
  RightHeaderWrapper: styled.div`
    display: flex;
    align-items: center;
    @media (max-width: 1440px) {
      align-items: center;
      display: flex;
    }
  `,
  ViewMore: styled.div`
    font-size: 1.2rem;
    font-weight: 600;
    color: ${(props) => props.theme.token.colorPrimary};
    text-decoration: underline;
    cursor: pointer;
    @media (max-width: 1079px) {
      font-size: 1rem;
    }
  `,
  AllowButton: styled(Button)`
    border-radius: ${({ theme }) => theme.token.borderRadiusLG};
    font-size: 1rem;
    height: 3rem;
    width: unset !important;
    background-color: ${({ theme }) => theme.token.colorBgActionButton};
    margin-right: 20px;
    @media (max-width: 1079px) {
      height: 2rem;
      font-size: 0.8rem;
    }
  `,
  Table: styled(Table)`
    transform: none !important;
    & .ant-table-thead tr .ant-table-cell {
      background-color: ${(props) => props.theme.token.colorPrimary};
      color: ${(props) => props.theme.token.colorTextLightSolid};
      font-size: 0.9rem;
      font-weight: 500;
    }
    .ant-table-cell-ellipsis {
      max-width: 100px;
    }
    @media screen and (max-width: 1079px) {
      .ant-table-thead tr .ant-table-cell {
        font-size: 0.75rem;
      }
    }
    .ant-table-thead tr .ant-table-cell::before {
      display: none;
    }

    .ant-table-thead tr .ant-table-cell .ant-table-column-has-sorters {
      border-top: ${(props) =>
        `1px solid ${props.theme.token.colorBorder} !important`};
    }
    .ant-table-body .ant-table-cell {
      border-bottom: 0px;
    }

    .ant-table-wrapper .ant-table-tbody > tr > td {
      padding: 0.5rem !important;
    }
    .ant-table-thead tr th {
      height: 2rem !important;
      padding: 0rem 0.5rem !important;
    }
    .collapseTable .ant-collapse-expand-icon span svg {
      fill: ${(props) => props.theme.token.colorTextLightSolid} !important;
    }
    .collapseTable .ant-collapse-header-text {
      color: ${(props) => props.theme.token.colorTextLightSolid};
    }

    .ant-switch-checked .ant-switch-inner {
      background-color: ${(props) =>
        props.theme.token.colorBgActionButton} !important;
    }

    .ant-table-thead {
      height: 3.18rem;
    }

    .ant-table-thead .ant-table-cell {
      &:hover {
        background: ${(props) =>
          props.theme.token.colorPrimaryBgHover} !important;
      }
    }
    .ant-table-body .ant-table-cell {
      padding: 0.5rem !important;
    }

    .ant-table-tbody .ant-table-row:hover {
      background: ${(props) => props.theme.token.colorBgLayout};
    }
    .ant-table-body {
      scroll-behavior: smooth; /* Enables smooth scrolling */
      /* overflow-x: hidden !important; */
    }
  `,
  ReloadSpan: styled.span`
    margin-left: 2rem;
    margin-right: 1rem;
    color: ${(props) => props.theme?.token.colorPrimary};
  `,
  TableWrapper: styled.div`
    height: 270px !important;
    background-color: ${(props) => props.theme.token.colorBgContainer} !important;
    border-radius: 5px !important;
  `,
};
export const RejectionMessageRow = styled(Row)`
  margin: auto;
  color: red;
  font-size: 1rem;
`;

export const columnSpan = (name) => {
  switch (name) {
    case name === "allTrade":
      return "8";
    case name === "pendingTrade":
      return "9";
    case name === "rejectionLogs":
      return "10";
    case name === "m2mAlerts":
      return "5";
    default:
      return "10";
  }
};
